const TOPICS = [
  { label: '热播电视剧', hot: true },
  { label: '最新电影', hot: true },
  { label: '西瓜视频同款', hot: true },
  { label: '国产剧推荐', hot: false },
  { label: '韩剧热榜', hot: false },
  { label: '美剧精选', hot: false },
  { label: '动漫番剧', hot: true },
  { label: '综艺节目', hot: false },
  { label: '纪录片', hot: false },
  { label: '经典重温', hot: false },
  { label: '高分推荐', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          热门话题标签，发现更多精彩内容
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((t, i) => (
            <a
              key={i}
              href="#"
              className={`inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                t.hot
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-background-50 text-foreground-700 border border-background-300 hover:border-primary-300 hover:text-primary-600'
              }`}
            >
              {t.hot && <i className="ri-fire-line text-xs"></i>}
              {t.label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}